import { KYMW1309Model } from '../kymw1309.model';
import { KYMW1309GetPromotionGoodsInfoModel } from '../vo/kymw1309-get-promotion-goods-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * バンドルミックスマッチ検索画面　プロモーション商品情報を取得するサービス
 *
 * @export GetPromotionGoodsInfoService
 * @class GetPromotionGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPromotionGoodsInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1309Model}
   * @memberof GetPromotionGoodsInfoService
   */
  private model: KYMW1309Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1309GetPromotionGoodsInfoModel}
   * @memberof GetPromotionGoodsInfoService
   */
  private vo: KYMW1309GetPromotionGoodsInfoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPromotionGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        PromotionNo: this.vo.promotionNo,
        PromotionDiv: this.vo.promotionDiv,
        PromotionName: this.vo.promotionName,
        CoopCode: this.vo.coopCode,
        PCode: this.vo.pCode,
        ClassCode: this.vo.classCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPromotionGoodsInfoService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1309Model>model;
    this.vo = vo;
    this.send('getPromotionGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPromotionGoodsInfoService
   */
  success(data: any): void {
    this.model.updateKYMW1309(data);
  }

}
